export default {
  NATSession: 'NAT session',
  SearchPlaceholder: 'Search source IP/destination domain name/destination IP',
  GatewayBranch: 'Gateway/Branch',
  BeforeConversion: 'Before conversion',
  ColumnLabel1: 'source IP/port—>destination domain name/IP/port',
  AfterConversion: 'After Conversion',
  SNAT: 'Source Address Translation',
  DNAT: 'Destination Address Translation',
  SNATandDNAT: 'Source Destination Address Translation',
  AcquisitionDevice: 'Acquisition Device',
}